import React, { useState, useEffect } from 'react';

import {
    useParams,
    Link,
} from 'react-router-dom';
import { FontAwesomeIcon as I } from '@fortawesome/react-fontawesome';
import {
    Grid,
    Typography,
    Stack,
    Box,
    IconButton,
    Divider,
    Container,
} from '@mui/material';

import { questionsData } from '@static/faq';
import { MessageBox } from '@components';

import { sx } from './sx';

interface QuestionsProps {
    id: string;
    question: string;
    topic: string;
    urlTopic: string;
    answer: string;
}

const Questions: React.FC = () => {
    const { topic } = useParams();
    const urlSearch = new URLSearchParams(window.location.search);
    const [questions, setQuestions] = useState([] as QuestionsProps[]);
    const { css } = sx();

    useEffect(() => {
        if (urlSearch.get('key')) {
            const result =
                questionsData.filter((item) =>
                    item.question.toLowerCase().includes(
                        String(urlSearch.get('key')).toLowerCase()) ||
                    item.answer.toLowerCase().includes(
                        String(urlSearch.get('key')).toLowerCase()));
            setQuestions(result);
        } else {
            if (topic) {
                const result =
                    questionsData.filter((item) => item.urlTopic === topic);
                setQuestions(result);
            }
        }
    }, []);

    return (
        <Container>
            <Box sx={{ ...css.sxBoxContainer }}>
                <Link
                    to={'/central-de-ajuda'}
                    style={{ ...css.sxLink }}>
                    <Typography
                        sx={{ ...css.sxTextLink }} variant='caption'>
                        <IconButton sx={{ ...css.sxIconLinkBack }}>
                            <I icon={['far', 'arrow-left-long']} />
                        </IconButton>
                        Voltar para a Central de Ajuda
                    </Typography>
                </Link>
                <Box sx={{ ...css.sxBoxGrid }}>
                    <Grid container spacing={2}>
                        <Grid item md={8} lg={8} sm={12} xs={12}>
                            <Typography sx={{ ...css.sxTitle }} variant='h2'>
                                {urlSearch.get('key') ?
                                    'Resultados para "'+urlSearch.get('key')+'"' :
                                    questions.length > 0 && questions[0].topic}
                            </Typography>
                        </Grid>
                        {questions.length > 0 ?
                            <Grid item md={8} lg={8} sm={12} xs={12}>
                                <Stack
                                    divider={
                                        <Divider
                                            flexItem
                                            sx={{ ...css.sxDivider }}
                                            orientation="horizontal" />}>
                                    {questions.map((question) => (
                                        <Link
                                            key={question.id}
                                            style={{ ...css.sxLinkQuestion }}
                                            // eslint-disable-next-line max-len
                                            to={'/central-de-ajuda/'+question.urlTopic+'/'+question.id}
                                            state={{
                                                fromSearch:
                                                    urlSearch.get('key') ? true : false,
                                            }}>
                                            <Box
                                                sx={{ ...css.sxBoxQuestion }}>
                                                <Typography
                                                    sx={{ ...css.sxQuestionText }}
                                                    variant='h3'>
                                                    {question.question}
                                                </Typography>
                                                <I
                                                    style={{ ...css.sxIconChevron }}
                                                    icon={['far', 'chevron-right']} />
                                            </Box>
                                        </Link>
                                    ))}
                                </Stack>
                            </Grid> :
                            <Grid item md={12} lg={12} sm={12} xs={12}>
                                <MessageBox
                                    message={'Não foi possível encontrar resultados'}
                                    type={'info'} />
                            </Grid>
                        }
                    </Grid>
                </Box>
            </Box>
        </Container>
    );
};

export { Questions };
